import moment from 'moment'
import dayjs from 'dayjs'

import { buildAssetUrl } from '../../../../../utils/imageUrl'
import { COUNTRY_OPTIONS } from './constants'

export const resolvePartnerLogo = (logo) => buildAssetUrl(logo)

export const formatTND = (value, decimals = 2) => {
  const num = Number(value)
  if (Number.isNaN(num)) return '—'
  return `${num.toLocaleString('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} TND`
}

export const formatDT = (value, decimals = 2) => {
  const num = Number(value)
  if (Number.isNaN(num)) return '—'
  return `${num.toLocaleString('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} DT`
}

export const formatDateFR = (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '—')

export const formatTimeFR = (value) => (value ? dayjs(value).format('HH:mm') : '')

export const formatDateTimeFR = (value) => (value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '—')

export const formatPeriode = (start, end) => `${formatDateFR(start)} → ${formatDateFR(end)}`

export const formatHourRange = (start, end) => {
  if (!start && !end) return '—'
  return `${start ?? '--:--'} – ${end ?? '--:--'}`
}

export const formatPax = (min, max) => {
  if (min == null && max == null) return '—'
  if (min === max) return `${min}`
  return `${min ?? 1} – ${max ?? min ?? 1}`
}

export const formatStock = (stock) => (stock == null ? '∞' : String(stock))

export const formatCountry = (code) =>
  COUNTRY_OPTIONS.find((c) => c.value === code)?.label ?? code ?? '—'

export const getInitials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('') || '?'

export const buildReference = (date = moment()) => {
  const stamp = dayjs(date).format('YYYYMMDD')
  const rand = Math.floor(10000 + Math.random() * 89999)
  return `REF-${stamp}-${rand}`
}
